import {Request} from 'common/domain/models/request';
import {EVENTS, MODALS, MODES} from 'common/domain/constants';
import VacationScheduleEndDateHelper from 'vacations-absences.module/features/myVacations/vacationScheduleEndDate.helper';
import {STATES} from 'common/domain/states';
import moment from 'moment';

class MyVacationsMobileController {
  constructor($scope,
              $rootScope,
              $timeout,
              $window,
              $q,
              $log,
              vacationEmployeeRepositoryService,
              vacationUserDataService,
              VacationScheduleEndDateService,
              loadingMobileService,
              vacationDelegationService,
              HelperDelegationsService,
              modalsBehaviourService,
              ManagerForEmployeeService) {
    'ngInject';
    this.scope = $scope;
    this.rootScope = $rootScope;
    this.timeout = $timeout;
    this.isMobileApp = $window.innerWidth < 1024;
    this.window = $window;
    this.q = $q;
    this.log = $log;

    this.vacationDelegationService = vacationDelegationService;
    this.modalsBehaviourService = modalsBehaviourService;
    this.helperDelegations = HelperDelegationsService;
    this.UserDataService = vacationUserDataService;
    this.employeeRepositoryService = vacationEmployeeRepositoryService;
    this.ManagerForEmployeeService = ManagerForEmployeeService;
    this.VacationScheduleEndDateService = VacationScheduleEndDateService;
    this.loadingMobileService = loadingMobileService;

    this.dateToday = new Date();
    this.year = this.dateToday.getFullYear();
    this.loaded = false;
    this.currentEmployee = {};
    this.openChoicesButtons = false;
    this.dayIsSelected = false;
    this.delegation = {};
    this.startDate = '';
  }

  $onInit() {
    this.userId = this.UserDataService.getEmployee().userId;
    this.urlDestination = STATES.VACATIONS_ABSENCES.DELEGATE;

    this.loadingMobileService.show();
    let promises = {
      employee    : this.employeeRepositoryService.getEmployee(this.userId, this.year, this.userInceptionId),
      schedule    : this.VacationScheduleEndDateService.get(),
      delegations : this.vacationDelegationService.getDelegations(this.userId)
    };
    this.q.all(promises).then(responses => {
      this._loadData(responses.employee);
      this._initVacationSchedule(responses.schedule);
      this._initDelegations(responses.delegations);
    }, error => {
      this.log.error('MyVacationsMobileController $onInit()', error);
    }).finally(() => {
      this.loadingMobileService.hide();
    });

    this.initFloatingActionButtons();

    this.modalsBehaviourService.reset();
    this.visitedDelegation = this.helperDelegations.getVisitDelegation(this.userId);
  }

  get requestModal() {
    const $modal = $(MODALS.REQUEST);
    return $modal;
  }

  get warningVacationModal() {
    const $modal = $(MODALS.WARNING_REQUEST_VACATION);
    return $modal;
  }

  get modalWarningDelegation() {
    const $modal = $(MODALS.WARNING_DELEGATION_MODAL);
    $modal.on('hidden.bs.modal', () => {
      this.helperDelegations.setVisitedDelegation(this.userId);
    });
    return $modal;
  }

  _loadData(employee) {
    this.currentEmployee = employee;
    this.rawPeriodDays = employee.periodInDays;
    this.user = employee.getProfile();
    this.availableVacations = employee.availableVacations;
    this.vacationCount = employee.getAgreementVacationCount();
    this.allPeriods = employee.allPeriods;
    this.loaded = true;
    this.loadedCalendarGrid  = false;
    this.timeout(() => {
      this.loadedCalendarGrid = true;
    }, 200);
  }

  _initVacationSchedule(schedule) {
    this.vacationScheduleEndDateHelper = new VacationScheduleEndDateHelper(schedule.startDate, schedule.endDate, this.availableVacations);
    this.modalsBehaviourService.warnLastDayShouldBeVisible = this.vacationScheduleEndDateHelper.start();
    this.vacationScheduleEndDate = this.vacationScheduleEndDateHelper.getViewDate();
  }

  _initDelegations(delegations) {
    this._findDelegationActive(delegations);
    this._showModalWarningDelegation();
  }

  requestData() {
    this.loaded = false;

    this.loadingMobileService.show();
    return this.employeeRepositoryService.getEmployee(this.userId,  this.year, this.userInceptionId)
      .then((employee) => {
        this._loadData(employee);
      })
      .finally(() => this.loadingMobileService.hide());
  }

  _findDelegationActive(delegations) {
    const today = moment().format('YYYY-MM-DD');
    this.delegation = this.vacationDelegationService
      .findDelegationActive(today, delegations);
  }

  _showModalWarningDelegation() {
    let delegationEmpty = this.helperDelegations.isDelegationEmpty(this.delegation);
    if (delegationEmpty || this.visitedDelegation) {
      return;
    }

    this.modalWarningDelegation.modal('show');
  }

  addEvent({startDate, endDate}) {
    this.requestData(this.userId, this.userInceptionId).then(() => {
      this.rootScope.$broadcast(EVENTS.ADD_PERIOD, {
        startDate: startDate.getMonth(),
        endDate: endDate,
      });
    });
  }

  openRequestHolidayModal() {
    this.requestHolidayMode = MODES.CREATE;
    this.timeout(() => {
      this.requestModal.modal('show');
      this.openChoicesButtons = false;
    });
  }

  reopenModalAfterFail(){
    this.requestHolidayMode = MODES.EDIT;
    this.timeout(() => {
      this.requestModal.modal('show');
      this.openChoicesButtons = false;
    });
  }

  isInception() {
    return !!this.userInceptionId;
  }

  setWarnModalDisplayed() {
    process.isWarnModalBeenDisplayed = true;
  }

  isWarnModalBeenDisplayed() {
    return process.isWarnModalBeenDisplayed;
  }

  getClasses() {
    return {
      'responsiveMobile': this.isMobileApp,
      'with-floating-action-buttons': this.isMobileApp
    };
  }

  initFloatingActionButtons() {
    this.floatingActionButtons = this._getFloatingActionButtons();
    this.choicesFloatingActionButtons = this._getChoicesFloatingActionButtons();
    this.inceptionFloatingActionButtons = this._getInceptionFloatingActionButtons();
  }

  _getFloatingActionButtons() {
    return [
      {
        literal: 'GLOBALS.BUTTON_ACTION.SUBMIT',
        literalWithChoices: 'GLOBALS.BUTTON_ACTION.CHOICES_QUESTION'
      }
    ];
  }

  _getChoicesFloatingActionButtons() {
    return [
      {
        literal: 'GLOBALS.BUTTON_ACTION.ABSENCES'
      },
      {
        literal: 'GLOBALS.BUTTON_ACTION.VACATIONS'
      }
    ];
  }

  _getInceptionFloatingActionButtons() {
    return [{
      literal: 'GLOBALS.BUTTON_ACTION.ASK_FOR_ABSENCES'
    }];
  }

  getFloatingClass() {
    return {
      'with-choices': this.openChoicesButtons
    };
  }

  hideChoicesButtons() {
    if (this.openChoicesButtons) {
      this.openChoicesButtons = false;
    }
  }

  toggleButtons() {
    this.openChoicesButtons = !this.openChoicesButtons;
  }

  requestVacations() {
    this.requestType = Request.TYPES.VACATION;
    this.openRequestHolidayModal();
  }

  requestAbsences() {
    this.requestType = Request.TYPES.ABSENCE;
    this.openRequestHolidayModal();
  }

  paginationPrevious() {
    this.loaded = false;
    this.year = this.year -1;
    this.dateToday = new Date(this.year , 11 , 1);
    this.dateToday.setFullYear(this.year);
    this.$onInit();
  }

  paginationNext() {
    this.loaded = false;
    this.year = this.year +1;
    this.dateToday = new Date(this.year , 0 , 1);
    this.$onInit();
  }

}

export default MyVacationsMobileController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/myVacationsMobile/myVacationsMobile.controller.js